import React from 'react';
import { Link, Plus, ShieldAlert } from 'lucide-react';

interface ConnectedCalendarsProps {
  connections: any[];
  loadingConns: boolean;
  onManageClick: () => void;
}

export function ConnectedCalendars({ connections, loadingConns, onManageClick }: ConnectedCalendarsProps) {
  return (
    <div style={{
      border: '1px solid var(--admin-card-border)',
      borderRadius: '0',
      backgroundColor: 'var(--admin-card-bg)',
      boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
      padding: '12px',
      display: 'flex',
      flexDirection: 'column',
      gap: '8px'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ 
          fontFamily: 'Inter',
          fontWeight: 600,
          fontSize: '13px',
          lineHeight: '19.5px',
          letterSpacing: '0px',
          color: 'var(--admin-card-text)', 
          display: 'flex', 
          alignItems: 'center', 
          gap: '6px' 
        }}>
          <Link size={14} style={{ color: '#3E8FA6' }} />
          Connected Calendars
        </span>
        <button
          onClick={onManageClick}
          style={{
            background: 'none',
            border: 'none',
            color: '#3E8FA6',
            fontFamily: 'Inter',
            fontWeight: 600,
            fontSize: '11px',
            lineHeight: '16.5px',
            letterSpacing: '0.28px',
            textAlign: 'center',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            padding: 0
          }}
        >
          <Plus size={12} /> Manage
        </button>
      </div>

      {loadingConns ? (
        <div style={{ color: 'var(--admin-card-subtext)', fontSize: '12px', padding: '8px 0' }}>Loading accounts...</div>
      ) : connections.length === 0 ? (
        <div style={{
          borderRadius: '0',
          border: '1px dashed #ef4444/30',
          backgroundColor: 'var(--admin-input-bg, rgba(255, 255, 255, 0.05))',
          padding: '12px',
          fontSize: '12px',
          color: '#ef4444',
          display: 'flex',
          alignItems: 'flex-start',
          gap: '8px'
        }}>
          <ShieldAlert size={14} style={{ marginTop: '2px', flexShrink: 0 }} />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <span>No calendar connections. Connect Google or Outlook Calendar in the Integrations page to sync.</span>
            <button
              onClick={onManageClick}
              style={{
                alignSelf: 'flex-start',
                background: '#3E8FA6',
                color: '#ffffff',
                border: 'none',
                borderRadius: '0',
                padding: '4px 8px',
                fontSize: '10px',
                fontWeight: 700,
                cursor: 'pointer'
              }}
            >
              Go to Integrations
            </button>
          </div>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {connections.map((c) => (
            <div key={c.id} style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '8px 12px',
              borderRadius: '0',
              backgroundColor: 'var(--admin-input-bg, rgba(255, 255, 255, 0.05))',
              border: '1px solid var(--admin-card-border)'
            }}>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontSize: '11px', fontWeight: 800, color: 'var(--admin-card-text)' }}>
                  {c.accountEmail}
                </span>
                <span style={{ 
                  fontFamily: 'Inter',
                  fontWeight: 400,
                  fontSize: '11px',
                  lineHeight: '16.5px',
                  letterSpacing: '0px',
                  color: '#7C8891', 
                  textTransform: 'capitalize' 
                }}>
                  {c.provider} Calendar
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
